import { CSSProperties } from 'react';
import { useSelector } from 'react-redux';
import { animated, useSpring } from 'react-spring';
import { getAnnouncement } from 'src/modules/Redux/slices/announcer';
import { Sparkle } from './Sparkle';
import { getActiveStore } from 'src/modules/Redux';
import { generateGradientFromHex } from '../../lib';

const styles: Record<string, CSSProperties> = {
    container: {
        position: 'fixed',
        bottom: 0,
        zIndex: 1,
        display: 'flex',
        width: '100vw',
        height: '12em',
        paddingBottom: '.5em',
        paddingTop: '.5em',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'center',
        flexShrink: 0,
        backgroundBlendMode: 'hard-light, normal, normal',
    },
    text: {
        filter: 'drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.2)) drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.10))',
        color: 'white',
        fontSize: '1.5em',
        fontWeight: 700,
    },
};

export function Announcer() {
    const announcerText = useSelector(getAnnouncement);

    const animationProps = useSpring({
        opacity: announcerText ? 1 : 0,
        transform: announcerText ? 'translateY(10px)' : 'translateY(100px)',
        config: {
            tension: 210,
            friction: 20,
        },
    });
    const activeStore = useSelector(getActiveStore);
    const color = activeStore?.brandColor || '#000000';
    const radialGradient = generateGradientFromHex(color);
    return (
        <>
            <animated.div
                style={{
                    ...styles.container,
                    ...animationProps,
                    background: radialGradient,
                    fontSize: 'clamp(14px, 4vw, 40px)',
                }}
            >
                <Sparkle />
                <p style={styles.text}>{announcerText}</p>
            </animated.div>
        </>
    );
}
